export const checkPasswordInvalidity = (password) => {
    const MINIMUM_PASSWORD_LENGTH = 6;

    if (!password || password.length < MINIMUM_PASSWORD_LENGTH) {
        return `Password must contain at least ${MINIMUM_PASSWORD_LENGTH} characters`;
    }

    if (/\s/.test(password)) {
        return "Password cannot contain whitespace";
    }

    return undefined;
};

export const getQueryParameter = (key, defaultValue) => {
    if (!window) {
        return defaultValue;
    }

    const searchParameters = new URLSearchParams(window.location.search);

    return searchParameters.get(key) ?? defaultValue;
};

export const deleteQueryConfigurationParameters = (keys) => {
    const searchParameters = new URLSearchParams(window.location.search);

    for (let key of keys) {
        searchParameters.delete(key);
    }

    window.history.replaceState({}, "", `${window.location.pathname}?${searchParameters}`);
};

export const getQueryConfiguration = () => {
    const applicationId = getQueryParameter("sv");
    const mode = getQueryParameter("md");
    const activateAccount = getQueryParameter("activate");
    const resetPassword = getQueryParameter("setpwd");
    const email = getQueryParameter("email");
    const token = getQueryParameter("guid");

    return {
        applicationId: applicationId,
        mode: mode,
        activateAccount: activateAccount,
        resetPassword: resetPassword,
        email: email,
        token: token,
        forceAuthenticationMode: activateAccount || resetPassword,
    };
};
